import React, { useContext } from 'react';
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import deLocale from '@fullcalendar/core/locales/de';
import frLocale from '@fullcalendar/core/locales/fr';
import { ContextUserProfile } from '../../../../../contexts/UserProfileContext';

const CalendarConfiguration = ({ children }) => {
    const { language } = useContext(ContextUserProfile);

    let locale;
    let firstDay;

    switch (language) {
        case 'es':
            locale = esLocale;
            firstDay = 1; // Lunes
            break;
        case 'de':
            locale = deLocale;
            firstDay = 1; // Lunes
            break;
        case 'fr':
            locale = frLocale;
            firstDay = 1; // Lunes
            break;
        default:
            locale = enLocale;
            firstDay = 0; // Domingo
            break;
    }

    return React.cloneElement(children, { locale, firstDay });
};

export default CalendarConfiguration;
